<template>
  <div class="segment">
    <div class="title">
      {{ title }}
    </div>
    <span v-if="!hideDateTime && (!modelProp.sendImmediately && modelProp.sendTime) ">Scheduled for:
      {{dateFormatter(modelProp.sendTime)}} </span>
    <radio-group
      :options="[{ value: true, text: 'Begin sending immediately'}, { value: false, text: 'Set Delivery Time'}]"
      v-model="sendImmediately" />
    <div v-if="!hideDateTime" class="schedule-container" :class="modelProp.sendImmediately ? 'disabled' : ''">
      <datetime class="schedule-datetime" type="datetime" step="1" :value="sendTimeForDatetime" @input="updateSendTime"
        placeholder="Select delivery time"
        :min-datetime="new Date().toISOString()"
        :max-datetime="new Date(Date.now() + 30 * 24 * 3600 * 1000).toISOString()" />
    </div>
    <div class="row">
      <i class="fas fa-info-circle" v-if="automated" @mouseover="displayInfo('message-info-interval')"
        @mouseleave="removeInfo('message-info-interval')" style="margin: auto 1rem;"></i>
      <radio-group v-if="automated" label="Interval Type" inline
        :options="[{ value: 'hours', text: 'Hours'}, { value: 'days', text: 'Days'}]"
        v-model="intervalType" />
    </div>
    <input-group v-if="automated" v-model="interval" value-type="number" placeholder="Interval"
      label="Interval" inline :min="1" />
    <div class="info" id="message-info-interval">
      <pre>
        Specify the frequency of your automated message. 
        (e.g. if you want your message to be sent once every 7 days, select "day" as an interval type and enter 7 into interval field)
      </pre>
    </div>
    <radio-group v-if="!modelProp.sendImmediately" v-model="withLocalTimezone"
      label="Send According To Local Timezone" inline
      :options="[{value: true, text: 'Yes'},{value: false, text: 'No'}]" />

    <div v-if="automated">
      <label class="mr-2 select-label">(Optional) Send Only:</label>
      <select v-model="daysToSend" id="days-to-send">
        <option value="-"> - </option>
        <option value="weekdays">Weekdays</option>
        <option value="weekend">Weekend</option>
      </select>
    </div>

  </div>

</template>

<script>
import RadioGroup from "@/views/PushNotification/UIComponents/RadioGroup";
import { Datetime } from 'vue-datetime'
import InputGroup from "@/views/PushNotification/UIComponents/InputGroup";
import formatters from "@/util/formatters";
import { displayMixin } from "@/util/displayMixin.js"

export default {
  data() {
    return {
      dateFormatter: formatters.dateFormatter
    }
  },
  name: "index",
  mixins: [displayMixin],
  components: {
    InputGroup,
    RadioGroup,
    Datetime
  },
  model: {
    prop: "modelProp",
    event: "modelEvent"
  },
  props: {
    modelProp: Object,
    title: String,
    automated: Boolean,
    hideDateTime: Boolean,
  },
  computed: {
    sendTimeForDatetime() {
      // Convert timestamp to ISO string for Datetime component
      if (this.modelProp && this.modelProp.sendTime) {
        if (typeof this.modelProp.sendTime === 'number') {
          return new Date(this.modelProp.sendTime).toISOString()
        } else if (typeof this.modelProp.sendTime === 'string') {
          // If it's already a string, try to parse it as a date
          const parsed = Date.parse(this.modelProp.sendTime)
          if (!isNaN(parsed)) {
            return new Date(parsed).toISOString()
          }
          return this.modelProp.sendTime
        }
      }
      return ''
    },
    sendImmediately: {
      get() {
        return this.modelProp.sendImmediately;
      },
      set(value) {
        this.$emit('modelEvent', { ...this.modelProp, sendImmediately: value });
      }
    },
    intervalType: {
      get() {
        return this.modelProp.intervalType;
      },
      set(value) {
        this.$emit('modelEvent', { ...this.modelProp, intervalType: value });
      }
    },
    interval: {
      get() {
        return this.modelProp.interval;
      },
      set(value) {
        this.$emit('modelEvent', { ...this.modelProp, interval: value });
      }
    },
    withLocalTimezone: {
      get() {
        return this.modelProp.withLocalTimezone;
      },
      set(value) {
        if (value) {
          alert("Local time zone push notifications should have at least 12 hours buffer. Otherwise it will not be sent for time zones that sent time already passed.")
        }
        this.$emit('modelEvent', { ...this.modelProp, withLocalTimezone: value });
      }
    },
    daysToSend: {
      get() {
        return this.modelProp.daysToSend;
      },
      set(value) {
        this.$emit('modelEvent', { ...this.modelProp, daysToSend: value });
      }
    }
  },
  methods: {
    updateSendTime(value) {
      // Convert ISO string back to timestamp when Datetime component updates
      if (value && this.modelProp) {
        const timestamp = Date.parse(value)
        if (!isNaN(timestamp)) {
          this.$emit('modelEvent', { ...this.modelProp, sendTime: timestamp });
        }
      }
    }
  }
}
</script>

<style scoped>
.segment {
  background-color: rgba(44, 44, 71, 0.46);
  margin: 30px 0;
  border-radius: 3px;
  padding: 20px 20px;
  color: white;
  font-size: 16px;
  font-weight: 400;
}

.title {
  font-size: 24px;
  font-weight: 500;
}

.schedule-container {
  margin: 20px 40px;
  position: relative;
  display: inline-block;
  padding: 5px;
}

.schedule-container.disabled {
  pointer-events: none;
  display: none;

}

.select-label {
  width: 15%;
  display: inline-block;
  color: #BB86FC;
}
</style>